<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 92%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.aaNumber" style="width: 140px;" size="mini" placeholder="资产编码"
                        clearable></el-input>
                    <el-input v-model="formDatas.aaName" style="width: 140px;" size="mini" placeholder="输入名称"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>

                    <el-select size="mini" v-model="formDatas.aacId" placeholder="分类" @change="partserch" clearable
                        style="width: 130px;">
                        <el-option v-for="item in aacTypearr || []" :label="item.aacName" :value="item.aacId"
                            :key="item.aacId">
                        </el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.aaStatus" clearable @change="partserch" placeholder="状态"
                        style="width: 110px">
                        <el-option label="闲置" :value="1" key="1"></el-option>
                        <el-option label="报废" :value="2" key="2"></el-option>
                        <el-option label="维修" :value="3" key="3"></el-option>
                        <el-option label="领用" :value="4" key="4"></el-option>
                        <el-option label="借用" :value="5" key="5"></el-option>
                        <el-option label="退租" :value="6" key="6"></el-option>
                        <el-option label="丢失" :value="7" key="7"></el-option>
                    </el-select>
                    <!-- <el-date-picker v-model="formDatas.auLevelDateStart" type="date" value-format="yyyy-MM-dd"
                        placeholder="离职开始日期" style="width: 130px" size="mini">
                    </el-date-picker> -
                    <el-date-picker v-model="formDatas.auLevelDateEnd" type="date" value-format="yyyy-MM-dd"
                        placeholder="离职结束日期" style="width: 130px" size="mini">
                    </el-date-picker> -->
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 5px">搜索</el-button>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="SerchMore"
                        style="margin-left: 5px">更多</el-button>
                    <el-button type="primary" size="mini" style="margin-right: 2px;"
                        @click="bulkImport = true">批量导入</el-button>
                    <el-dropdown size="mini" split-button type="warning" style="margin-right: 2px;" @click="Out()"
                        @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="danger" size="mini" @click="BulkDelete">批量删除</el-button>
                    <el-button type="warning" size="mini" @click="initFinance" v-if="post == 1 || post == 2">初始化财务</el-button>
                </el-row>
            </div>
            <div style="width: 8%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增资产</el-button>


                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="aaId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑公司资产' : '新增公司资产'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <!-- 表单字段顺序与资产列表列序保持一致 -->
                            <el-form-item label="资产分类" prop="aaClassify">
                                <el-select v-model="form.aaClassify" placeholder="请选择" clearable style="width: 80%;">
                                    <el-option v-for="item in aaClassifyArr" :label="item" :value="item" :key="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="资产类别" prop="aaCategory">
                                <el-select v-model="form.aaCategory" placeholder="请选择" clearable style="width: 80%;">
                                    <el-option v-for="item in aaCategoryArr" :label="item" :value="item" :key="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="资产来源" prop="aaOwnerType">
                                <el-select v-model="form.aaOwnerType" clearable @change="form.aaMoneyBuy = '',
                                    form.aaMoneyHireMonth = '', $forceUpdate()"
                                    placeholder="请选择" style="width: 130px">
                                    <el-option label="租用" value="租用" key="1"></el-option>
                                    <el-option label="自购" value="自购" key="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="资产编码" prop="aaNumber">
                                <el-input v-model="form.aaNumber" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="资产名称" prop="aaName">
                                <el-input v-model="form.aaName" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="规格型号" prop="aaSpecModel">
                                <el-input v-model="form.aaSpecModel" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="设备所在地" prop="aaAddress">
                                <el-input v-model="form.aaAddress" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="购买金额" prop="aaMoneyBuy" v-if="form.aaOwnerType == '自购'">
                                <el-input v-model="form.aaMoneyBuy" style="width: 80%;" placeholder="请输入"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="原值(入账价值)" prop="aaMoneyOriginal">
                                <el-input v-model="form.aaMoneyOriginal" style="width: 80%;" placeholder="请输入"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="折旧年限(年)" prop="aaDepreciationYears">
                                <el-input v-model="form.aaDepreciationYears" style="width: 80%;" placeholder="不填按资产类别自动"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="预计净残值率" prop="aaResidualRate">
                                <el-input v-model="form.aaResidualRate" style="width: 80%;" placeholder="不填默认5%"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="入账日期" prop="aaDateAccount">
                                <el-date-picker v-model="form.aaDateAccount" type="date" value-format="yyyy-MM-dd"
                                    placeholder="财务记账日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="已折旧月数" prop="aaDepreciatedMonths">
                                <el-input v-model="form.aaDepreciatedMonths" style="width: 80%;" placeholder="不填按入账日期自动计算"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="本月租赁费" prop="aaMoneyHireMonth"
                                v-if="form.aaOwnerType == '租用'">
                                <el-input v-model="form.aaMoneyHireMonth" style="width: 80%;" placeholder="请输入"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="购买渠道" prop="aaPurchaseChannels">
                                <el-input v-model="form.aaPurchaseChannels" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="配置" prop="aaConfiguration">
                                <el-input v-model="form.aaConfiguration" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="资产厂商" prop="amId">
                                <el-select v-model="form.amId" placeholder="请选择分类">
                                    <el-option v-for="item in amTypearr || []" :label="item.amName" :value="item.amId"
                                        :key="item.amId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="过保日期" prop="aaDateWarranty">
                                <el-date-picker v-model="form.aaDateWarranty" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="意外保过保日期" prop="aaDateWarrantyAccident">
                                <el-date-picker v-model="form.aaDateWarrantyAccident" type="date"
                                    value-format="yyyy-MM-dd" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="SN码" prop="aaCodeSn">
                                <el-input v-model="form.aaCodeSn" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="绑定账号" prop="aaBindAccount">
                                <el-input v-model="form.aaBindAccount" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="处置日期" prop="aaDateDisposal">
                                <el-date-picker v-model="form.aaDateDisposal" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="处置方式" prop="aaDisposalManner">
                                <el-select v-model="form.aaDisposalManner" placeholder="请选择" clearable style="width: 80%;">
                                    <el-option v-for="item in disposalMannerArr" :label="item" :value="item" :key="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="处置收入" prop="aaDisposalIncome">
                                <el-input v-model="form.aaDisposalIncome" style="width: 80%;" placeholder="请输入"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="备注" prop="aaDes">
                                <el-input v-model="form.aaDes" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="入库日期" prop="aaDateBuy">
                                <el-date-picker v-model="form.aaDateBuy" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="产品分类" prop="aacId">
                                <el-select v-model="form.aacId" placeholder="请选择分类">
                                    <el-option v-for="item in aacTypearr || []" :label="item.aacName"
                                        :value="item.aacId" :key="item.aacId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="图片" prop="aaFiles">
                                <my-upload ref="Imgupload" @fileChange="fileChange" :filearr.sync="fileList" :limit="limit"
                                    @removeAfter="removeAfter" style="margin: 10px 5px 5px;">
                                </my-upload>

                                <!-- <el-input v-model="form.aaFiles" style="width: 80%;" disabled placeholder="请先上传"></el-input> -->
                            </el-form-item>
                            <!-- <el-form-item label="折旧规则" prop="ardId">
                                <el-select v-model="form.ardId" placeholder="请选择">
                                    <el-option v-for="item in RuleArr || []" :label="item.ardName" :value="item.ardId"
                                        :key="item.ardId">
                                    </el-option>
                                </el-select>
                            </el-form-item> -->

                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">
                <div style="max-height: 700px; overflow-y: scroll">
                    <el-descriptions :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                        <el-descriptions-item label="资产编号">{{ DetailArr.aaNumber }}</el-descriptions-item>
                        <el-descriptions-item label="产品分类">{{ DetailArr.aacName }}</el-descriptions-item>
                        <el-descriptions-item label="资产产商">{{ DetailArr.amName }}</el-descriptions-item>
                        <el-descriptions-item label="设备所在地">{{ DetailArr.aaAddress }}</el-descriptions-item>
                        <el-descriptions-item label="入库日期">{{ DetailArr.aaDateBuy }}</el-descriptions-item>
                        <el-descriptions-item label="过保日期">{{ DetailArr.aaDateWarranty }}</el-descriptions-item>
                        <el-descriptions-item label="拥有方式">{{ DetailArr.aaOwnerType }}</el-descriptions-item>
                        <el-descriptions-item label="采购单价">{{ DetailArr.aaMoneyBuy }}</el-descriptions-item>
                        <el-descriptions-item label="租用方式">{{ DetailArr.aaMoneyHireManner }}</el-descriptions-item>
                        <el-descriptions-item label="月租">{{ DetailArr.aaMoneyHireMonth }}</el-descriptions-item>
                        <el-descriptions-item label="年租">{{ DetailArr.aaMoneyHireYear }}</el-descriptions-item>
                        <el-descriptions-item label="购买渠道">{{ DetailArr.aaPurchaseChannels }}</el-descriptions-item>
                        <el-descriptions-item label="配置">{{ DetailArr.aaConfiguration }}</el-descriptions-item>
                        <el-descriptions-item label="SN码">{{ DetailArr.aaCodeSn }}</el-descriptions-item>
                        <el-descriptions-item label="绑定账号">{{ DetailArr.aaBindAccount }}</el-descriptions-item>
                        <el-descriptions-item label="图片">
                            <el-image ref="scrImg" id="scrimg" v-if="DetailArr.aaFiles"
                                :src="DetailArr.aaFiles.split(',')[0]" alt="" fit="cover"
                                style="width: 100%;height: 50px;"
                                :preview-src-list="DetailArr.aaFiles.split(',')"></el-image>
                        </el-descriptions-item>
                        <!-- 财务核算字段 -->
                        <el-descriptions-item label="固定资产分类">{{ DetailArr.aaClassify }}</el-descriptions-item>
                        <el-descriptions-item label="资产类别">{{ DetailArr.aaCategory }}</el-descriptions-item>
                        <el-descriptions-item label="规格型号">{{ DetailArr.aaSpecModel }}</el-descriptions-item>
                        <el-descriptions-item label="原值(不含税)">{{ DetailArr.aaMoneyOriginal }}</el-descriptions-item>
                        <el-descriptions-item label="折旧年限">{{ DetailArr.aaDepreciationYears }}</el-descriptions-item>
                        <el-descriptions-item label="净残值率">{{ DetailArr.aaResidualRate }}</el-descriptions-item>
                        <el-descriptions-item label="预计净残值">{{ DetailArr.aaResidualValue }}</el-descriptions-item>
                        <el-descriptions-item label="入账日期">{{ DetailArr.aaDateAccount }}</el-descriptions-item>
                        <el-descriptions-item label="预计到期日期">{{ DetailArr.aaDateDue }}</el-descriptions-item>
                        <el-descriptions-item label="已折旧月数">{{ DetailArr.aaDepreciatedMonths }}</el-descriptions-item>
                        <el-descriptions-item label="本月折旧额">{{ DetailArr.aaMonthDepreciation }}</el-descriptions-item>
                        <el-descriptions-item label="累计折旧">{{ DetailArr.aaAccumulatedDepreciation }}</el-descriptions-item>
                        <el-descriptions-item label="处置日期">{{ DetailArr.aaDateDisposal }}</el-descriptions-item>
                        <el-descriptions-item label="处置方式">{{ DetailArr.aaDisposalManner }}</el-descriptions-item>
                        <el-descriptions-item label="处置收入">{{ DetailArr.aaDisposalIncome }}</el-descriptions-item>
                        <el-descriptions-item label="当前使用者">{{ DetailArr.aaBorrowAuName }}</el-descriptions-item>
                        <el-descriptions-item label="部门">{{ DetailArr.auDepartment }}</el-descriptions-item>
                        <!-- <el-descriptions-item label="归属">{{ DetailArr.auBelong }}</el-descriptions-item> -->
                        <el-descriptions-item label="设备状态">
                            <el-tag size="mini">{{ DetailArr.aaStatus == 1 ? '闲置' :
                                DetailArr.aaStatus == 2 ? '报废' : DetailArr.aaStatus
                                    == 3 ? '维修' : DetailArr.aaStatus == 4 ? '领用' : DetailArr.aaStatus == 5 ? '借用' :
                                        DetailArr.aaStatus == 6 ? '退租' : '丢失' }}</el-tag>
                        </el-descriptions-item>
                        <!-- <el-descriptions-item label="关联配件">{{ DetailArr.ajFittingsList }}</el-descriptions-item> -->
                    </el-descriptions>
                    <div style="margin: 10px 20px;">关联配件</div>
                    <div style="width: 100%;height:200px;">
                        <ve-table ref="vetable" v-if="DetailArr.ajFittingsList && DetailArr.ajFittingsList.length > 0"
                            :columns="columnsFittings" :table-data="DetailArr.ajFittingsList" :max-height="200"
                            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            :checkbox-option="checkboxOption" row-key-field-name="afId"
                            :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                        <div v-show="DetailArr.ajFittingsList && DetailArr.ajFittingsList.length == 0"
                            class="empty-data">
                            暂无关联</div>
                    </div>
                    <div style="margin: 10px 20px;">关联手机卡</div>
                    <div style="width: 100%;height:200px;">
                        <ve-table ref="vetable"
                            v-if="DetailArr.ajMobileCardList && DetailArr.ajMobileCardList.length > 0"
                            :columns="columnsCard" :table-data="DetailArr.ajMobileCardList" :max-height="200"
                            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            :checkbox-option="checkboxOption" row-key-field-name="amcId"
                            :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                        <div v-show="DetailArr.ajMobileCardList && DetailArr.ajMobileCardList.length == 0"
                            class="empty-data">
                            暂无关联</div>
                    </div>
                </div>
            </el-dialog>
            <!-- 筛选 -->
            <el-dialog title="更多搜索" :visible.sync="IsSerch" width="70%" top="8vh" :close-on-click-modal="false">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formDatas" :model="formDatas" label-position="left" label-width="115px"
                            @submit.native.prevent>
                            <!-- 字段顺序与资产列表列序保持一致,两列等宽网格排布 -->
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="资产分类">
                                        <el-select v-model="formDatas.aaClassify" clearable placeholder="请选择"
                                            style="width: 85%;">
                                            <el-option v-for="item in aaClassifyArr" :label="item" :value="item"
                                                :key="item"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="资产类别">
                                        <el-select v-model="formDatas.aaCategory" clearable placeholder="请选择"
                                            style="width: 85%;">
                                            <el-option v-for="item in aaCategoryArr" :label="item" :value="item"
                                                :key="item"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="资产来源">
                                        <el-select v-model="formDatas.aaOwnerType" clearable placeholder="请选择"
                                            style="width: 85%;">
                                            <el-option label="租用" value="租用" key="1"></el-option>
                                            <el-option label="自购" value="自购" key="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="资产编码">
                                        <el-input v-model="formDatas.aaNumber" style="width: 85%;" placeholder="请输入"
                                            clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="资产名称">
                                        <el-input v-model="formDatas.aaName" style="width: 85%;" placeholder="请输入"
                                            clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="规格型号">
                                        <el-input v-model="formDatas.aaSpecModel" style="width: 85%;"
                                            placeholder="请输入" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="当前使用人">
                                        <el-input v-model="formDatas.aaBorrowAuName" style="width: 85%;"
                                            placeholder="请输入" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="领用日期">
                                        <el-date-picker v-model="formDatas.aubrBorrowDateStart" type="date"
                                            value-format="yyyy-MM-dd" placeholder="开始日期" style="width: 40%;">
                                        </el-date-picker>
                                        <span style="margin: 0 4px;">-</span>
                                        <el-date-picker v-model="formDatas.aubrBorrowDateEnd" type="date"
                                            value-format="yyyy-MM-dd" placeholder="结束日期" style="width: 40%;">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="使用部门">
                                        <el-input v-model="formDatas.auDepartment" style="width: 85%;"
                                            placeholder="请输入" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="设备所在地">
                                        <el-input v-model="formDatas.aaAddress" style="width: 85%;" placeholder="请输入"
                                            clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="使用状态">
                                        <el-select v-model="formDatas.aaStatus" clearable placeholder="请选择"
                                            style="width: 85%;">
                                            <el-option label="闲置" :value="1" key="1"></el-option>
                                            <el-option label="报废" :value="2" key="2"></el-option>
                                            <el-option label="维修" :value="3" key="3"></el-option>
                                            <el-option label="领用" :value="4" key="4"></el-option>
                                            <el-option label="借用" :value="5" key="5"></el-option>
                                            <el-option label="退租" :value="6" key="6"></el-option>
                                            <el-option label="丢失" :value="7" key="7"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="入账日期">
                                        <el-date-picker v-model="formDatas.aaDateAccountStart" type="date"
                                            value-format="yyyy-MM-dd" placeholder="开始日期" style="width: 40%;">
                                        </el-date-picker>
                                        <span style="margin: 0 4px;">-</span>
                                        <el-date-picker v-model="formDatas.aaDateAccountEnd" type="date"
                                            value-format="yyyy-MM-dd" placeholder="结束日期" style="width: 40%;">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="配置">
                                        <el-input v-model="formDatas.aaConfiguration" style="width: 85%;"
                                            placeholder="请输入" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="资产厂商">
                                        <el-select v-model="formDatas.amId" clearable placeholder="请选择"
                                            style="width: 85%;">
                                            <el-option v-for="item in amTypearr || []" :label="item.amName"
                                                :value="item.amId" :key="item.amId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="过保日期">
                                        <el-date-picker v-model="formDatas.aaDateWarrantyStart" type="date"
                                            value-format="yyyy-MM-dd" placeholder="开始日期" style="width: 40%;">
                                        </el-date-picker>
                                        <span style="margin: 0 4px;">-</span>
                                        <el-date-picker v-model="formDatas.aaDateWarrantyEnd" type="date"
                                            value-format="yyyy-MM-dd" placeholder="结束日期" style="width: 40%;">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="意外保过保日期">
                                        <el-date-picker v-model="formDatas.aaDateWarrantyAccidentStart" type="date"
                                            value-format="yyyy-MM-dd" placeholder="开始日期" style="width: 40%;">
                                        </el-date-picker>
                                        <span style="margin: 0 4px;">-</span>
                                        <el-date-picker v-model="formDatas.aaDateWarrantyAccidentEnd" type="date"
                                            value-format="yyyy-MM-dd" placeholder="结束日期" style="width: 40%;">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="SN码">
                                        <el-input v-model="formDatas.aaCodeSn" style="width: 85%;" placeholder="请输入"
                                            clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="处置日期">
                                        <el-date-picker v-model="formDatas.aaDateDisposalStart" type="date"
                                            value-format="yyyy-MM-dd" placeholder="开始日期" style="width: 40%;">
                                        </el-date-picker>
                                        <span style="margin: 0 4px;">-</span>
                                        <el-date-picker v-model="formDatas.aaDateDisposalEnd" type="date"
                                            value-format="yyyy-MM-dd" placeholder="结束日期" style="width: 40%;">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="处置方式">
                                        <el-select v-model="formDatas.aaDisposalManner" clearable placeholder="请选择"
                                            style="width: 85%;">
                                            <el-option v-for="item in disposalMannerArr" :label="item" :value="item"
                                                :key="item"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="入库日期">
                                        <el-date-picker v-model="formDatas.aaDateBuyStart" type="date"
                                            value-format="yyyy-MM-dd" placeholder="开始日期" style="width: 40%;">
                                        </el-date-picker>
                                        <span style="margin: 0 4px;">-</span>
                                        <el-date-picker v-model="formDatas.aaDateBuyEnd" type="date"
                                            value-format="yyyy-MM-dd" placeholder="结束日期" style="width: 40%;">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="产品分类">
                                        <el-select v-model="formDatas.aacId" clearable placeholder="请选择"
                                            style="width: 85%;">
                                            <el-option v-for="item in aacTypearr || []" :label="item.aacName"
                                                :value="item.aacId" :key="item.aacId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item style="text-align: center; margin-top: 10px;">
                                <el-button type="primary" @click="partserch(), IsSerch = false">立即搜索</el-button>
                                <el-button @click="closeSizer(), IsSerch = false">取 消</el-button>
                            </el-form-item>
                        </el-form>

                    </div>
                </div>
            </el-dialog>
            <!-- 借出 -->
            <el-dialog :title="formBw.aubrBorrowReturn == 2 ? formBw.name + '[出借]' : formBw.name + '[领用]'"
                :visible.sync="ISborrow" width="70%" top="8vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formBw" :model="formBw" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="员工" prop="auId">
                                <el-select v-model="formBw.auId" filterable placeholder="请选择">
                                    <el-option v-for="item in userArr || []" :label="item.auName" :value="item.auId"
                                        :key="item.auId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="数量" prop="aubrThisNum">
                                <el-input v-model.number="formBw.aubrThisNum" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item> -->
                            <el-form-item label="领用日期" prop="aubrBorrowDate">
                                <el-date-picker v-model="formBw.aubrBorrowDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="计划归还日期" prop="aubrReturnPlanDate">
                                <el-date-picker v-model="formBw.aubrReturnPlanDate" type="date"
                                    value-format="yyyy-MM-dd" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="是否同时借出配件" prop="hasFitting" v-if="form.aubrType == 1">
                                <el-radio-group v-model="formBw.hasFitting">
                                    <el-radio :label="1">否</el-radio>
                                    <el-radio :label="2">是</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="备注" prop="aubrThisDes">
                                <el-input v-model="formBw.aubrThisDes" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="CloseBorrow">取 消</el-button>
                            <el-button type="primary" @click="sureBorrow">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>
            <!-- 故障 -->
            <el-dialog :title="formBk.name + '[故障]'" :visible.sync="ISBreak" width="70%" top="8vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formBk" :model="formBk" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="故障时间" prop="aahTime">
                                <el-date-picker v-model="formBk.aahTime" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="故障说明" prop="aahDes">
                                <el-input v-model="formBk.aahDes" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="CloseBreak">取 消</el-button>
                            <el-button type="primary" @click="sureBreak">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>
            <!-- 编辑日期 -->
            <el-dialog title="编辑" :visible.sync="dbtrue" width="50%" top="8vh">
                <el-date-picker v-if="TypeId == 1" v-model="dateUpdata" type="date" value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
                <el-select v-model="dateUpdata" placeholder="请选择" filterable v-if="TypeId == 2">
                    <el-option v-for="item in EditArr || []" :label="item.key" :value="item.value" :key="item.id">
                    </el-option>
                </el-select>
                <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="CloseBreak">取 消</el-button> -->
                    <el-button type="primary" @click="sureDate">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 批量导入 -->
            <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <!-- Excel表格格式说明图 -->
                <el-image style="width: 100%; margin-bottom: 10px;"
                    src="https://trainappsub.aojuai.com/upassets/202608/83163ab6465d4cc484efec5ff44ee2d0.png"
                    :preview-src-list="['https://trainappsub.aojuai.com/upassets/202608/83163ab6465d4cc484efec5ff44ee2d0.png']">
                </el-image>
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary" @click="downloadItTemplate"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div style="margin: 10px;font-size: 18px;" v-if="bulkData.length != 0">
                    <span style="color: #0080FF;">一共{{ importData.numAll }}条;</span>
                    <span style="color: #0E9A00;margin-left: 5px;">成功{{ importData.numSuccess }}条;</span>
                    <span style="color: red;margin-left: 5px;">失败{{ importData.numFail }}条</span>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <el-button type="success" @click="bulkImportClose(() => { bulkImport = false })">关 闭</el-button>
                </div>
            </el-dialog>
            <!-- 资产归还连同配件 -->
            <el-dialog title="归还资产" :visible.sync="ReturnZc" width="70%" top="15vh">
                <p>是否归还此用户所有领借物品</p>
                <el-radio-group v-model="hasFitting">
                    <el-radio :label="1">否</el-radio>
                    <el-radio :label="2">是</el-radio>
                </el-radio-group>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="ReturnZc = false">取 消</el-button>
                    <el-button type="primary" @click="sureReturnzc">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 借还记录 -->
            <el-dialog title="借还记录" :visible.sync="ReturnShow" width="70%" top="15vh">
                <div style="width: 90%;height: 100%;margin: 10px auto;overflow: hidden;">
                    <el-card v-for="(item, index) in ReturnArr" :key="index" style="margin: 10px;">
                        <p style="color: #E6A23C;">使&ensp;用&ensp;人:&emsp;{{ item.auName }}</p>
                        <p style="color: #0e0d0d;">领用日期:&emsp;{{ item.aubrBorrowDate }}</p>
                        <p style="color: #0e0d0d;"> 领借类型:&emsp;{{ item.aubrBorrowReturn == 1 ? '领用' : '借用' }}</p>
                        <p style="color: #0E9A00;" v-if="item.aubrBorrowStatus == 1"> 借还状态:&emsp;在使用</p>
                        <p style="color: #0e0d0d;" v-if="item.aubrBorrowStatus == 2"> 借还状态:&emsp;已归还</p>
                        <p style="color: #9a0015;" v-if="item.aubrBorrowStatus == 3"> 借还状态:&emsp;已损耗</p>
                        <p style="color: #0e0d0d;">归还时间:&emsp;{{ item.returntime }}</p>

                    </el-card>
                </div>
            </el-dialog>
            <!-- 财务核算编辑(独立接口,只提交财务字段) -->
            <el-dialog :title="formFinance.aaName + '[财务核算]'" :visible.sync="ISFinance" width="50%" top="10vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formFinanceRef" :model="formFinance" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="购买金额(含税)">
                                <el-input v-model="formFinance.aaMoneyBuy" style="width: 80%;" placeholder="请输入"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="原值(入账价值,不含税)">
                                <el-input v-model="formFinance.aaMoneyOriginal" style="width: 80%;" placeholder="请输入"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="折旧年限(年)">
                                <el-input v-model="formFinance.aaDepreciationYears" style="width: 80%;"
                                    placeholder="不填按资产类别自动生成" @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="预计净残值率(%)">
                                <el-input v-model="formFinance.aaResidualRate" style="width: 80%;" placeholder="不填默认5%"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="入账日期">
                                <el-date-picker v-model="formFinance.aaDateAccount" type="date" value-format="yyyy-MM-dd"
                                    placeholder="财务记账日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="已折旧月数">
                                <el-input v-model="formFinance.aaDepreciatedMonths" style="width: 80%;"
                                    placeholder="不填按入账日期自动计算" @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="本月租赁费(月租)" v-if="formFinance.aaOwnerType == '租用'">
                                <el-input v-model="formFinance.aaMoneyHireMonth" style="width: 80%;" placeholder="请输入"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="ISFinance = false">取 消</el-button>
                            <el-button type="primary" @click="sureFinance">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>
            <!-- 处置编辑(独立接口,只提交处置字段) -->
            <el-dialog :title="formDisposal.aaName + '[处置]'" :visible.sync="ISDisposal" width="50%" top="10vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formDisposalRef" :model="formDisposal" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="处置日期">
                                <el-date-picker v-model="formDisposal.aaDateDisposal" type="date"
                                    value-format="yyyy-MM-dd" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="处置方式">
                                <el-select v-model="formDisposal.aaDisposalManner" placeholder="请选择" clearable
                                    style="width: 80%;">
                                    <el-option v-for="item in disposalMannerArr" :label="item" :value="item" :key="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="处置收入">
                                <el-input v-model="formDisposal.aaDisposalIncome" style="width: 80%;" placeholder="请输入"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="备注(异常说明)">
                                <el-input v-model="formDisposal.aaDes" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="ISDisposal = false">取 消</el-button>
                            <el-button type="primary" @click="sureDisposal">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { BrowserQRCodeSvgWriter } from '@zxing/browser';
import {
    getAjAssetsList, addAjAssets, updateAjAssets, deleteAjAssets, addAjUserBorrow, updateAjAssetsStatus, getAjAssetsItems,
    getAjManufacturerList, getAjAssetsClassList, getAjAssetsDetails, getAjUserListAll, getAjRuleDepreciationList, addAjAssetsHitch, uploadAjAssetsIt,
    exportAjAssetsItTemplate, exportAjAssets, updateAjAssetsReturn, updateAjAssetsReturnStore, getAjUserBorrowReturnList,
    updateAjAssetsFinance, updateAjAssetsDisposal, initAjAssetsFinance
} from "../../api/api";

export default {
    name: "",
    components: {},
    data() {
        return {
            rowKeyname: 'aaId',
            TypeId: '',
            updataId: '',

            EditArr: [],
            aaStatusArr: [
                {
                    key: '闲置',
                    value: 1,
                    id: 1,
                },
                {
                    key: '报废',
                    value: 2,
                    id: 2,
                },
                {
                    key: '丢失',
                    value: 7,
                    id: 7,
                }
            ],
            columnsCard: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "amcNumber",
                    key: "amcNumber",
                    title: "手机卡",
                    align: "center",
                    width: 150,
                    fixed: 'left',
                    edit: false,
                },
                {
                    field: "aocName",
                    key: "aocName",
                    title: "运营商",
                    align: "center",
                    width: 150,

                    edit: false,
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "部门",
                    align: "center",
                    width: 150,

                    edit: false,
                },

                {
                    field: "amcBorrowDate",
                    key: "amcBorrowDate",
                    title: "领用日期",
                    align: "center",
                    width: 150,

                    edit: false,
                },
                {
                    field: "amcNumberCornet",
                    key: "amcNumberCornet",
                    title: "短号",
                    align: "center",
                    width: 150,

                    edit: false,
                },

                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

            ],
            ReturnShow: false,
            ReturnZc: false,
            hasFitting: '',
            TemstrongArr: [],
            // IT批量导入结果统计(新接口上传即入库,统计由前端按行状态计算)
            importData: { numAll: 0, numSuccess: 0, numFail: 0 },
            bulkData: [],
            bulkDataCopy: [],
            bulkImport: false,
            columnsImport: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "status",
                    key: "status",
                    title: "状态",
                    width: 100,
                    align: "center",
                    fixed: 'left',
                },
                {
                    field: "statusMsg",
                    key: "statusMsg",
                    title: "状态备注",
                    width: 150,
                    align: "center",
                },
                // 以下列序与IT导入模板Excel表头一致
                {
                    field: "aaClassify",
                    key: "aaClassify",
                    title: "资产分类",
                    width: 100,
                    align: "center",
                },
                {
                    field: "aaCategory",
                    key: "aaCategory",
                    title: "资产类别",
                    width: 100,
                    align: "center",
                },
                {
                    field: "aaOwnerType",
                    key: "aaOwnerType",
                    title: "资产来源",
                    width: 100,
                    align: "center",
                },
                {
                    field: "aaNumber",
                    key: "aaNumber",
                    title: "资产编码",
                    width: 130,
                    align: "center",
                },
                {
                    field: "aaName",
                    key: "aaName",
                    title: "资产名称",
                    width: 120,
                    align: "center",
                },
                {
                    field: "aaSpecModel",
                    key: "aaSpecModel",
                    title: "规格型号",
                    align: "center",
                    width: 120,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "aaAddress",
                    key: "aaAddress",
                    title: "设备所在地",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaMoneyBuy",
                    key: "aaMoneyBuy",
                    title: "购买金额",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaMoneyHireMonth",
                    key: "aaMoneyHireMonth",
                    title: "本月租赁费",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaPurchaseChannels",
                    key: "aaPurchaseChannels",
                    title: "购买渠道",
                    align: "center",
                    width: 120,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "aaConfiguration",
                    key: "aaConfiguration",
                    title: "配置",
                    align: "center",
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "amName",
                    key: "amName",
                    title: "资产厂商",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaDateWarranty",
                    key: "aaDateWarranty",
                    title: "过保日期",
                    align: "center",
                    width: 120,
                },
                {
                    field: "aaDateWarrantyAccident",
                    key: "aaDateWarrantyAccident",
                    title: "意外保过保日期",
                    align: "center",
                    width: 130,
                },
                {
                    field: "aaCodeSn",
                    key: "aaCodeSn",
                    title: "SN码",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaBindAccount",
                    key: "aaBindAccount",
                    title: "绑定账号",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaDes",
                    key: "aaDes",
                    title: "备注",
                    align: "center",
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "aaDateBuy",
                    key: "aaDateBuy",
                    title: "入库日期",
                    align: "center",
                    width: 120,
                },
                {
                    field: "aacName",
                    key: "aacName",
                    title: "产品分类",
                    width: 100,
                    align: "center",
                },
            ], //表格的列



            dateUpdata: '',
            dbtrue: false,

            formBk: {

            },
            ISBreak: false,
            fileList: [],
            limit: 6,
            userArr: [],
            formBw: {

            },
            ISborrow: false,

            RuleArr: [],
            aacTypearr: [],//资产分类
            amTypearr: [],//厂商
            IsSerch: false,
            dialog: false,
            edit: false,
            form: {
                aaName: '',
                aaNumber: '',
                aacId: '',
                amId: '',
                aaOwnerType: '',
                aaDateBuy: '',
                aaDateWarranty: '',
                aaPurchaseChannels: '',
                aaConfiguration: '',
                aaCodeSn: '',
                aaBindAccount: '',
                aaDes: '',
                aaFiles: '',
                aaRuleDepreciate: '',
                // 财务核算字段
                aaClassify: '',
                aaCategory: '',
                aaSpecModel: '',
                aaMoneyOriginal: '',
                aaDepreciationYears: '',
                aaResidualRate: '',
                aaDateAccount: '',
                aaDepreciatedMonths: '',
                // 处置字段
                aaDateDisposal: '',
                aaDisposalManner: '',
                aaDisposalIncome: '',
            },
            // 固定资产分类(固定资产/低值易耗品,影响折旧口径)
            aaClassifyArr: ['固定资产', '低值易耗品'],
            // 资产类别(固定资产五大类,对应折旧年限20/10/4/3/5年)
            aaCategoryArr: ['房屋建筑物', '机器设备', '运输工具', '电子设备', '办公家具'],
            // 处置方式(后端校验枚举)
            disposalMannerArr: ['出售', '报废', '毁损', '盘亏', '捐赠'],
            // 财务核算独立编辑弹窗(走 updateAjAssetsFinance)
            ISFinance: false,
            formFinance: {},
            // 处置独立编辑弹窗(走 updateAjAssetsDisposal)
            ISDisposal: false,
            formDisposal: {},
            rules: {
                aaName: [{
                    required: true,
                    message: '请输入资产名称',
                    trigger: 'blur'
                }
                ],
                aaNumber: [{
                    required: true,
                    message: '请输入资产编码',
                    trigger: 'blur'
                }
                ],
            },
            DetailArr: [],
            IsDetail: false,
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                // 列顺序与名称对齐后端导出资产Excel(资产11787125471557.xlsx / AjAssetsExcel)
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 40,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 30,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "aaClassify",
                    key: "aaClassify",
                    title: "资产分类",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                    // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
beforeVisibleChange: ({ nextVisible }) => {
    if (nextVisible) this.loadHeaderFilter('aaClassify');
    return true;
},
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'aaClassifyListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'aaClassifyListString');
                        },
                    },
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaCategory",
                    key: "aaCategory",
                    title: "资产类别",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                    // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
beforeVisibleChange: ({ nextVisible }) => {
    if (nextVisible) this.loadHeaderFilter('aaCategory');
    return true;
},
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'aaCategoryListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'aaCategoryListString');
                        },
                    },
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaOwnerType",
                    key: "aaOwnerType",
                    title: "资产来源",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                    // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
beforeVisibleChange: ({ nextVisible }) => {
    if (nextVisible) this.loadHeaderFilter('aaOwnerType');
    return true;
},
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'aaOwnerTypeListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'aaOwnerTypeListString');
                        },
                    },
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "aaNumber",
                    key: "aaNumber",
                    title: "资产编码",
                    width: 100,
                    align: "center",
                    fixed: 'left',
                    edit: true,

                },
                {
                    field: "aaName",
                    key: "b",
                    title: "资产名称",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                    // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
beforeVisibleChange: ({ nextVisible }) => {
    if (nextVisible) this.loadHeaderFilter('aaName');
    return true;
},
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'aaNameListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'aaNameListString');
                        },
                    },
                    align: "center",
                    width: 180,
                    edit: true,
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.getDetail(row.aaId)}
                                >
                                    {row.aaName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "aaSpecModel",
                    key: "aaSpecModel",
                    title: "规格型号",
                    align: "center",
                    width: 110,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "aaBorrowAuName",
                    key: "aaBorrowAuName",
                    title: "当前使用人",
                    align: "center",
                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "aaBorrowDate",
                    key: "aaBorrowDate",
                    title: "领用日期",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                        // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) this.loadHeaderFilter('aaBorrowDate');
                            return true;
                        },
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'aubrBorrowDateListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'aubrBorrowDateListString');
                        },
                    },
                    width: 100,
                    align: "center",
                    // fixed: 'left',
                },
                {
                    field: "auDateEntry",
                    key: "auDateEntry",
                    title: "入职时间",
                    align: "center",
                    edit: false,
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auDateEntry}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "使用部门",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                    // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
beforeVisibleChange: ({ nextVisible }) => {
    if (nextVisible) this.loadHeaderFilter('auDepartment');
    return true;
},
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'auDepartmentListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'auDepartmentListString');
                        },
                    },
                    align: "center",
                    // fixed: 'left',
                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "aaAddress",
                    key: "aaAddress",
                    title: "设备所在地",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                    // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
beforeVisibleChange: ({ nextVisible }) => {
    if (nextVisible) this.loadHeaderFilter('aaAddress');
    return true;
},
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'aaAddressListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'aaAddressListString');
                        },
                    },
                    align: "center",
                    width: 110,
                    edit: true,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "aaMoneyBuy",
                    key: "aaMoneyBuy",
                    title: "购买金额",
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "aaMoneyOriginal",
                    key: "aaMoneyOriginal",
                    title: "原值(入账价值)",
                    align: "center",
                    width: 110,
                },
                {
                    // 折旧方法为导出专用派生列:有原值即按年限平均法计提(与后端导出逻辑一致)
                    field: "aaDepreciationMethod",
                    key: "aaDepreciationMethod",
                    title: "折旧方法",
                    align: "center",
                    width: 90,
                    renderBodyCell: ({ row }, h) => {
                        return row.aaMoneyOriginal != null ? '年限平均法' : '';
                    },
                },
                {
                    field: "aaDepreciationYears",
                    key: "aaDepreciationYears",
                    title: "折旧年限(年)",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaResidualRate",
                    key: "aaResidualRate",
                    title: "预计净残值率",
                    align: "center",
                    width: 100,
                    // 后端存小数(0.05),展示转百分比(5%)
                    renderBodyCell: ({ row }) => {
                        const v = row.aaResidualRate;
                        if (v === null || v === undefined || v === '') return '';
                        return parseFloat((Number(v) * 100).toFixed(2)) + '%';
                    },
                },
                {
                    field: "aaResidualValue",
                    key: "aaResidualValue",
                    title: "预计净残值",
                    align: "center",
                    width: 90,
                },
                {
                    field: "aaDateAccount",
                    key: "aaDateAccount",
                    title: "入账日期",
                    align: "center",
                    edit: false,
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.aaDateAccount, 'aaDateAccount', rowIndex, row.aaId, 1)}>{row.aaDateAccount}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "aaDateDue",
                    key: "aaDateDue",
                    title: "预计到期日期",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaDepreciatedMonths",
                    key: "aaDepreciatedMonths",
                    title: "已折旧月数",
                    align: "center",
                    width: 90,
                },
                {
                    field: "aaMonthDepreciation",
                    key: "aaMonthDepreciation",
                    title: "本月折旧额",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaDepreciationSubject",
                    key: "aaDepreciationSubject",
                    title: "本月折旧科目",
                    align: "center",
                    width: 110,
                },
                {
                    field: "aaAccumulatedDepreciation",
                    key: "aaAccumulatedDepreciation",
                    title: "累计折旧",
                    align: "center",
                    width: 90,
                },
                {
                    field: "aaMoneyValue",
                    key: "aaMoneyValue",
                    title: "账面净值",
                    align: "center",
                    width: 90,
                },
                {
                    field: "aaMoneyHireMonth",
                    key: "aaMoneyHireMonth",
                    title: "本月租赁费",
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "aaPurchaseChannels",
                    key: "aaPurchaseChannels",
                    title: "购买渠道",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                    // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
beforeVisibleChange: ({ nextVisible }) => {
    if (nextVisible) this.loadHeaderFilter('aaPurchaseChannels');
    return true;
},
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'aaPurchaseChannelsListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'aaPurchaseChannelsListString');
                        },
                    },
                    align: "center",
                    edit: true,
                    width: 120,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
              
                {
                    field: "aaConfiguration",
                    key: "aaConfiguration",
                    title: "配置",
                    align: "center",
                    edit: true,
                    width: 200,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "amName",
                    key: "amName",
                    title: "资产厂商",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                    // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
beforeVisibleChange: ({ nextVisible }) => {
    if (nextVisible) this.loadHeaderFilter('amName');
    return true;
},
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'amNameListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'amNameListString');
                        },
                    },
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaDateWarranty",
                    key: "aaDateWarranty",
                    title: "过保日期",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                    // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
beforeVisibleChange: ({ nextVisible }) => {
    if (nextVisible) this.loadHeaderFilter('aaDateWarranty');
    return true;
},
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'aaDateWarrantyListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'aaDateWarrantyListString');
                        },
                    },
                    align: "center",
                    edit: false,
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;height:40px;line-height:40px;display:flex;justify-content: center;align-items: center;">
                                <div style="width:70%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.aaDateWarranty, 'aaDateWarranty', rowIndex, row.aaId, 1)}>{row.aaDateWarranty}</div>
                                {
                                    row.aaDateWarranty ? <el-button
                                        size="mini"
                                        type="text"
                                        style="margin-left:5px;color:red;"
                                        on-click={() => this.handleRenew2(row)}
                                    >
                                        续保
                                    </el-button> : ''
                                }

                            </div>

                        );
                    },
                },
                {
                    field: "aaDateWarrantyAccident",
                    key: "aaDateWarrantyAccident",
                    title: "意外保过保日期",
                    align: "center",
                    edit: false,
                    width: 130,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;height:40px;line-height:40px;display:flex;justify-content: center;align-items: center;">
                                <div style="width:70%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.aaDateWarrantyAccident, 'aaDateWarrantyAccident', rowIndex, row.aaId, 1)}>{row.aaDateWarrantyAccident}</div>

                                {
                                    row.aaDateWarrantyAccident ? <el-button
                                        size="mini"
                                        type="text"
                                        style="margin-left:5px;color:red;"
                                        on-click={() => this.handleRenew(row)}
                                    >
                                        续保
                                    </el-button> : ''
                                }

                            </div>
                        );
                    },
                },
                {
                    field: "aaCodeSn",
                    key: "aaCodeSn",
                    title: "SN码",
                    align: "center",
                    edit: true,
                    width: 100,
                },

                {
                    field: "aaBindAccount",
                    key: "aaBindAccount",
                    title: "绑定账号",
                    align: "center",
                    edit: true,
                    width: 100,
                },
                {
                    field: "aaDateDisposal",
                    key: "aaDateDisposal",
                    title: "处置日期",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aaDisposalManner",
                    key: "aaDisposalManner",
                    title: "处置方式",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                        // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) this.loadHeaderFilter('aaDisposalManner');
                            return true;
                        },
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'aaDisposalMannerListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'aaDisposalMannerListString');
                        },
                    },
                    align: "center",
                    width: 80,
                },
                {
                    field: "aaDisposalIncome",
                    key: "aaDisposalIncome",
                    title: "处置收入",
                    align: "center",
                    width: 90,
                },
                {
                    field: "aaDes",
                    key: "aaDes",
                    title: "备注",
                    align: "center",
                    edit: true,
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    // 入库日期为原"购入日期",Excel存量列保留在尾部
                    field: "aaDateBuy",
                    key: "aaDateBuy",
                    title: "入库日期",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                    // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
beforeVisibleChange: ({ nextVisible }) => {
    if (nextVisible) this.loadHeaderFilter('aaDateBuy');
    return true;
},
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'aaDateBuyListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'aaDateBuyListString');
                        },
                    },
                    align: "center",
                    edit: false,
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.aaDateBuy, 'aaDateBuy', rowIndex, row.aaId, 1)}>{row.aaDateBuy}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "aacName",
                    key: "aacName",
                    title: "产品分类",
                    filter: {
                        filterList: [],
                        isMultiple: true,
                    // 点击漏斗时懒加载筛选选项(带缓存),大数据量期间面板先显示加载中
beforeVisibleChange: ({ nextVisible }) => {
    if (nextVisible) this.loadHeaderFilter('aacName');
    return true;
},
                        // 表头筛选确认:选中值写入ListString参数后重新查询
                        filterConfirm: (filterList) => {
                            const labels = filterList.filter(x => x.selected).map(x => x.label);
                            this.searchByNameFieldCopy(labels, 'aacNameListString');
                        },
                        filterReset: () => {
                            this.searchByNameFieldCopy([], 'aacNameListString');
                        },
                    },
                    width: 100,
                    align: "center",
                },
                {
                    field: "aaFiles",
                    key: "aaFiles",
                    title: "图片",
                    align: "center",
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aaFiles ? <el-image ref="scrImg" id="scrimg" src={row.aaFiles.split(',')[0]} alt="" fit="fill" style="width: 100%;height: 50px;"
                                        previewSrcList={row.aaFiles.split(',')}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },
                },
                

                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "sn",
                    title: "SN码操作",
                    align: "center",
                    width: 80,
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>

                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: #E6A23C;margin-right:10px"
                                        on-click={() => this.goToSN(row)}
                                    >
                                        保修
                                    </el-button>
                                }

                            </span>
                        );
                    },
                },
                {
                    field: "aaStatus",
                    key: "aaStatus",
                    title: "使用状态",
                    align: "center",
                    width: 80,
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span onDblclick={() => this.getdbtrue(row.aaStatus, 'aaStatus', rowIndex, row.aaId, 2, this.aaStatusArr, 11)}>
                                {
                                    row.aaStatus == 1 ? <el-tag size="mini" type="success" > 闲置 </el-tag> : row.aaStatus == 2 ? <el-tag size="mini" type="info" > 报废 </el-tag> :
                                        row.aaStatus == 3 ? <el-tag size="mini" type="warning" > 维修 </el-tag> : row.aaStatus == 4 ? <el-tag size="mini" type="danger" > 领用 </el-tag> : row.aaStatus == 5 ?
                                            <el-tag size="mini" type="danger" > 借用 </el-tag> : row.aaStatus == 6 ?
                                                <el-tag size="mini" type="danger" > 退租 </el-tag> : <el-tag size="mini" type="danger" > 丢失 </el-tag>
                                }
                            </span>
                        );
                    },

                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 270,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleDown(row)}
                                >
                                    下载二维码
                                </el-button>
                                {
                                    row.aaOwnerType == '租用' && row.aaStatus != 6 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: #E6A23C;margin-right:10px"
                                        on-click={() => this.throwALease(row)}
                                    >
                                        退租
                                    </el-button> : <span></span>
                                }
                                {
                                    row.aaStatus != 2 && row.aaStatus != 3 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: #E6A23C;margin-right:10px"
                                        on-click={() => this.addBreak(row)}
                                    >
                                        报告故障
                                    </el-button> : <span></span>
                                }
                                {
                                    row.aaStatus == 1 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: #67C23A"
                                        on-click={() => this.addBorrow(row, 2)}
                                    >
                                        出借
                                    </el-button> : <span></span>
                                }
                                {
                                    row.aaStatus == 1 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red;margin:0 10px"
                                        on-click={() => this.addBorrow(row, 1)}
                                    >
                                        领用
                                    </el-button> : <span></span>
                                }
                                {
                                    row.aaStatus == 4 || row.aaStatus == 5 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.addReturn(row)}
                                    >
                                        归还
                                    </el-button> : <span></span>
                                }
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.getHis(row)}
                                >
                                    借还记录
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: #409EFF"
                                    on-click={() => this.openFinance(row)}
                                >
                                    财务核算
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: #E6A23C"
                                    on-click={() => this.openDisposal(row)}
                                >
                                    处置
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>

                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            columnsFittings: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "afName",
                    key: "b",
                    title: "配件名称",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "afNumber",
                    key: "afNumber",
                    title: "配件编号",
                    width: 150,
                    align: "center",
                    edit: false,
                },
                {
                    field: "afcName",
                    key: "afcName",
                    title: "配件分类",
                    width: 100,
                    align: "center",

                },
                {
                    field: "amName",
                    key: "amName",
                    title: "资产厂商",
                    align: "center",
                    width: 100,

                },
                {
                    field: "afDateBuy",
                    key: "afDateBuy",
                    title: "购入日期",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "afDateWarranty",
                    key: "afDateWarranty",
                    title: "过保日期",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "afOwnerType",
                    key: "afOwnerType",
                    title: "拥有方式",
                    align: "center",
                    edit: false,
                    width: 100,
                },


                {
                    field: "afDes",
                    key: "afDes",
                    title: "备注",
                    align: "center",
                    edit: false,
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "aaFiles",
                    key: "aaFiles",
                    title: "图片",
                    align: "center",
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aaFiles ? <el-image ref="scrImg" id="scrimg" src={row.aaFiles.split(',')[0]} alt="" fit="fill" style="width: 100%;height: 50px;"
                                        previewSrcList={row.aaFiles.split(',')}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },
                },
                
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

            ],
            tableData: [],
            post: null,
            formDatas: {
                aaConfiguration: '',
                aaCodeSn: '',
                aaSpecModel: '',
                aaBorrowAuName: '',
                auBelong: '',
                auDepartment: '',
                aaName: '',
                aaNumber: '',
                aacId: '',
                amId: '',
                aaOwnerType: '',
                aaStatus: '',
                aaDateBuyStart: '',
                aaDateBuyEnd: '',
                aaDateAccountStart: '',
                aaDateAccountEnd: '',
                aaDateWarrantyStart: '',
                aaDateWarrantyEnd: '',
                aaDateWarrantyAccidentStart: '',
                aaDateWarrantyAccidentEnd: '',
                // 固定资产管理筛选参数
                aaClassify: '',
                aaCategory: '',
                aaDisposalManner: '',
                aaDateDisposalStart: '',
                aaDateDisposalEnd: '',
                // 表头多选筛选参数(逗号分隔)
                aaClassifyListString: '',
                aaCategoryListString: '',
                aaOwnerTypeListString: '',
                aaNameListString: '',
                aubrBorrowDateListString: '',
                auDepartmentListString: '',
                aaAddressListString: '',
                aaPurchaseChannelsListString: '',
                amNameListString: '',
                aaDateWarrantyListString: '',
                aaDisposalMannerListString: '',
                aaDateBuyListString: '',
                aacNameListString: '',
                dmDelete: 1,
                currentPage: 1,
                pageSize: 20,
            },
            ReturnArr: [],
            // 表头筛选项配置:colKey=列key, item=getAjAssetsItems白名单字段, param=查询ListString参数名(领用日期两者不同名), options=静态枚举数据源
            headerFilterConfigs: [
                { colKey: 'aaClassify', item: '', param: 'aaClassifyListString', options: 'static:aaClassifyArr' },
                { colKey: 'aaCategory', item: '', param: 'aaCategoryListString', options: 'static:aaCategoryArr' },
                { colKey: 'aaOwnerType', item: 'aaOwnerType', param: 'aaOwnerTypeListString' },
                { colKey: 'aaName', item: 'aaName', param: 'aaNameListString' },
                { colKey: 'aaBorrowDate', item: 'aaBorrowDate', param: 'aubrBorrowDateListString' },
                { colKey: 'auDepartment', item: 'auDepartment', param: 'auDepartmentListString' },
                { colKey: 'aaAddress', item: 'aaAddress', param: 'aaAddressListString' },
                { colKey: 'aaPurchaseChannels', item: 'aaPurchaseChannels', param: 'aaPurchaseChannelsListString' },
                { colKey: 'amName', item: 'amName', param: 'amNameListString' },
                { colKey: 'aaDateWarranty', item: 'aaDateWarranty', param: 'aaDateWarrantyListString' },
                { colKey: 'aaDisposalManner', item: '', param: 'aaDisposalMannerListString', options: 'static:disposalMannerArr' },
                { colKey: 'aaDateBuy', item: 'aaDateBuy', param: 'aaDateBuyListString' },
                { colKey: 'aacName', item: 'aacName', param: 'aacNameListString' },
            ],
        };
    },
activated() {
	        this.post = localStorage.getItem("post");
	        var status = this.$route.query.id;
        var aacId = this.$route.query.aacId;
        const aaOwnerType = this.$route.query.aaOwnerType;;
        if (status) {
            console.log(aacId);
            this.formDatas.aaStatus = status == 0 ? '' : status * 1
            this.formDatas.aacId = aacId == 0 ? '' : aacId * 1
        }
        if (aaOwnerType) {
            console.log(aaOwnerType);
            this.formDatas.aaOwnerType = aaOwnerType
            this.formDatas.aacId = aacId == 0 ? '' : aacId * 1
        }
        getAjManufacturerList().then(res => {
            this.amTypearr = res.data
        })
        getAjAssetsClassList().then(res => {
            this.aacTypearr = res.data
        })
        getAjUserListAll({ checkStatus: 2 }).then(res => {
            this.userArr = res.data
        })
        getAjRuleDepreciationList().then(res => {
            this.RuleArr = res.data
        })
        this.getList();
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {

        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;

    },

    mounted() {

    },
    methods: {
        // 续保2
        handleRenew2(row) {
            //    是否要续保
            this.$confirm('是否要续保?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const aaDateWarranty = this.addOneYear(row.aaDateWarranty);
                updateAjAssets({ aaId: row.aaId, aaDateWarranty }).then(res => {
                    if (res.data) {
                        this.$message.success('续保成功');
                        this.getList();
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消续保'
                });
            });
        },
        addOneYear(dateString) {
            const date = new Date(dateString);
            date.setFullYear(date.getFullYear() + 1);

            // 格式化日期为YYYY-MM-DD
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
        // 续保
        handleRenew(row) {
            //    是否要续保
            this.$confirm('是否要续保?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const aaDateWarrantyAccident = this.addOneYear(row.aaDateWarrantyAccident);
                updateAjAssets({ aaId: row.aaId, aaDateWarrantyAccident }).then(res => {
                    if (res.data) {
                        this.$message.success('续保成功');
                        this.getList();
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消续保'
                });
            });
        },
        async handleDown(row) {
            // 创建二维码
            const writer = new BrowserQRCodeSvgWriter();
            const qrSvg = await writer.write(row.aaNumberUrl, 200, 200);

            // 创建文字元素
            const textElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            textElement.setAttribute('x', '100');
            textElement.setAttribute('y', '195');
            textElement.setAttribute('text-anchor', 'middle');
            textElement.setAttribute('font-family', 'Arial, sans-serif');
            textElement.setAttribute('font-size', '14');
            textElement.setAttribute('fill', '#000');
            textElement.textContent = '';

            // 创建组合SVG
            const combinedSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            combinedSvg.setAttribute('viewBox', '0 0 200 195');
            combinedSvg.setAttribute('width', '200');
            combinedSvg.setAttribute('height', '200');
            combinedSvg.appendChild(qrSvg);
            combinedSvg.appendChild(textElement);

            // 转换为PNG
            const svgBlob = new Blob([new XMLSerializer().serializeToString(combinedSvg)], { type: 'image/svg+xml' });
            const url = URL.createObjectURL(svgBlob);

            const img = new Image();
            img.src = url;

            await new Promise((resolve) => {
                img.onload = resolve;
                img.onerror = () => {
                    URL.revokeObjectURL(url);
                    throw new Error('图片加载失败');
                };
            });

            const canvas = document.createElement('canvas');
            canvas.width = 200;
            canvas.height = 210;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            // 清理资源
            URL.revokeObjectURL(url);
            // 下载PNG
            let qrImageUrl = ''
            qrImageUrl = canvas.toDataURL('image/png');
            URL.revokeObjectURL(img);
            const link = document.createElement('a');
            link.href = qrImageUrl;
            link.download = row.aaName + '---' + row.aaNumber + '.png';
            link.click();
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjAssets({ aaIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },

        goToSN(row) {
            window.open(`https://newthink.lenovo.com.cn/deviceGuarantee.html?selname=${row.aaCodeSn}`);
        },
        searchByNameField(labels, id) {
            this.bulkData = this.bulkDataCopy.filter(
                (x) => labels.length === 0 || labels.includes(x[id]),
            );
        },
        searchByNameFieldCopy(labels, id) {
            // 表头筛选确认/重置:去掉label的[count]后缀转CSV写入ListString参数(空选清空)后重新查询
            const arr = (labels || []).map(item => item.substring(0, item.indexOf('[') > -1 ? item.indexOf('[') : item.length));
            this.formDatas[id] = arr.length ? arr.toString() : '';
            this.partserch();
        },
        // 将filterList写入列定义并同步到ve-table内部克隆列(非响应式),再强制Filter组件重渲染
        syncFilterList(colKey, filterList) {
            const col = this.columns.find(c => c.key === colKey || c.field === colKey);
            if (col && col.filter) {
                col.filter.filterList = filterList;
            }
            const vetable = this.$refs['vetable'];
            if (!vetable) return;
            const walk = (comp) => {
                if (comp.column && comp.column.filter && (comp.column.key === colKey || comp.column.field === colKey)) {
                    comp.column.filter.filterList = filterList;
                    comp.$forceUpdate();
                }
                comp.$children.forEach(walk);
            };
            walk(vetable);
        },
        // 点击表头漏斗时懒加载筛选选项(带缓存):动态列调接口拉distinct值,静态列用枚举;大数据量期间面板先显示"加载中"
        async loadHeaderFilter(colKey) {
            const cfg = this.headerFilterConfigs.find(c => c.colKey === colKey);
            if (!cfg) return;
            const col = this.columns.find(c => c.key === colKey || c.field === colKey);
            if (!col || !col.filter) return;
            const selected = (this.formDatas[cfg.param] || '').split(',').filter(Boolean);
            const buildList = (options, withCount) => options.map((name, index) => ({
                label: withCount && name.num !== undefined ? `${name.name}[${name.num}]` : name,
                value: index,
                selected: selected.includes(String(withCount ? name.name : name)),
            }));
            // 已缓存则仅回显选中态
            if (col.filter._loaded) {
                const old = col.filter.filterList || [];
                const refreshed = old.map(x => {
                    const name = x.label.substring(0, x.label.indexOf('[') > -1 ? x.label.indexOf('[') : x.label.length);
                    return { ...x, selected: selected.includes(name) };
                });
                this.syncFilterList(colKey, refreshed);
                return;
            }
            col.filter._loaded = true;
            if (cfg.options && cfg.options.startsWith('static:')) {
                // 静态枚举(资产分类/资产类别/处置方式),本地数据直接生成
                const arr = this[cfg.options.split(':')[1]] || [];
                this.syncFilterList(colKey, buildList(arr, false));
            } else {
                // 先显示加载中,数据到达后替换
                this.syncFilterList(colKey, [{ label: '加载中...', value: -1, selected: false }]);
                try {
                    const res = await getAjAssetsItems({ itemType: 2, item: cfg.item });
                    this.syncFilterList(colKey, buildList(res.data || [], true));
                } catch (e) {
                    this.syncFilterList(colKey, [{ label: '加载失败,请重试', value: -1, selected: false }]);
                    col.filter._loaded = false;
                }
            }
        },

        getHis(row) {
            getAjUserBorrowReturnList({ aaId: row.aaId }).then(res => {
                if (res.data) {
                    this.ReturnArr = res.data;
                    this.ReturnShow = true;
                    console.log(this.ReturnArr);
                }
            })
        },
        throwALease(row) {
            this.$confirm("是否确定要退租吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    updateAjAssetsReturnStore({ aaId: row.aaId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "退还成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        sureReturnzc() {
            this.$confirm("是否确定要归还吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    updateAjAssetsReturn({ aaId: this.aaId, hasFitting: this.hasFitting }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "归还成功!",
                            });
                            this.ReturnZc = false;
                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        addReturn(row) {
            this.ReturnZc = true;
            this.aaId = row.aaId;
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },

        Out(command) {
            console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                exportAjAssets({ aaIds: this.selectedRowKeysCollection.toString(), ...this.formDatas }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });
                        this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = []

                    }
                })
            } else {
                this.openLoading()
                exportAjAssets({ exportType: 1, ...this.formDatas }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            }
        },


        // searchByNameField(labels, id) {
        //     this.bulkData = this.bulkDataCopy.filter(
        //         (x) => labels.length === 0 || labels.includes(x[id]),
        //     );
        // },
        // IT批量导入:上传即入库,返回逐行导入结果(成功/失败+原因),前端仅做结果展示与统计
        async updatabulk(file, fileList) {
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAssetsIt(Data).then(res => {
                this.loadings.close()
                const resultList = res.data || [];
                this.bulkData = resultList;
                this.bulkDataCopy = resultList;
                // 按行状态统计导入结果(后端状态为"成功"/"失败"文本)
                this.importData = {
                    numAll: resultList.length,
                    numSuccess: resultList.filter(x => x.status == '成功').length,
                    numFail: resultList.filter(x => x.status == '失败').length,
                };
                // 数据已入库,刷新列表
                this.getList();
            }).catch(() => {
                this.loadings.close()
            })
        },
        // 下载IT批量导入模板(接口文件流下载)
        downloadItTemplate() {
            this.openLoading()
            exportAjAssetsItTemplate().then(res => {
                this.loadings.close()
                const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                let link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.setAttribute('download', '固定资产IT导入模板.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }).catch(() => {
                this.loadings.close()
                this.$message({
                    type: 'error',
                    message: '模板下载失败',
                });
            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];

                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        filterTag(value, row) {
            return row.status == value;
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        removeAfter(file) {
            console.log(file,this.fileList);
            // const url = this.form.aaFiles.findIndex(item => item === file)
            // this.form.aaFiles.splice(url, 1)
        },
        sureDate() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(this.dateKeys, this.dateUpdata);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aaId = this.keysId;
                    if (this.updataId) {
                        updateAjAssetsStatus(jsonObj).then(res => {
                            if (res.status == 200) {
                                this.$nextTick(() => {
                                    console.log(this.tableData[this.dateIndexs], this.dateKeys);
                                    this.tableData[this.dateIndexs][this.dateKeys] = this.dateUpdata
                                });
                                this.dbtrue = false;
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                            }

                        })
                    } else {
                        updateAjAssets(jsonObj).then(res => {
                            if (res.status == 200) {
                                this.$nextTick(() => {
                                    console.log(this.tableData[this.dateIndexs], this.dateKeys);
                                    this.tableData[this.dateIndexs][this.dateKeys] = this.dateUpdata
                                });
                                this.dbtrue = false;
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                            }

                        })
                    }

                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getdbtrue(val, key, index, id, typeid, arr, updataid) {
            console.log("双击", val, key, index);
            this.dbtrue = true;
            this.dateUpdata = val;
            this.dateKeys = key;
            this.dateIndexs = index;
            this.keysId = id;
            this.TypeId = typeid;
            this.EditArr = arr;
            this.updataId = updataid;
        },
        // 故障
        addBreak(val) {
            this.$nextTick(() => {
                this.formBk.aahThisId = val.aaId;
                this.formBk.aahType = 1;
                this.formBk.name = val.aaName;
            })

            this.ISBreak = true;
        },
        sureBreak() {

            this.$confirm("是否确定要报告故障吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    addAjAssetsHitch(this.formBk).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "出借成功!",
                            });
                            this.CloseBreak()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        CloseBreak() {
            this.ISBreak = false;

            this.$refs['formBk'].resetFields();
        },

        // 上传图片
        fileChange(file) {
            console.log(this.form.aaFiles, this.fileList);
            if (this.form.aaFiles.length > 0 && this.form.aaFiles) {
                this.form.aaFiles.push(...file)
            } else {
                this.$set(this.form, 'aaFiles', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },

        addBorrow(val, id) {
            this.$nextTick(() => {
                this.formBw.aubrThisId = val.aaId;
                this.formBw.aubrType = 1;
                this.formBw.aubrBorrowReturn = id;
                this.formBw.name = val.aaName;
            })

            this.ISborrow = true;
        },
        sureBorrow() {
            this.$confirm("是否确定要出借吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    addAjUserBorrow(this.formBw).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "出借成功!",
                            });
                            this.CloseBorrow()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        CloseBorrow() {
            this.ISborrow = false;

            this.$refs['formBw'].resetFields();
        },

        closeSizer() {
            this.formDatas = {
                aaConfiguration: '',
                aaCodeSn: '',
                aaSpecModel: '',
                aaBorrowAuName: '',
                auBelong: '',
                auDepartment: '',
                aaName: '',
                aaNumber: '',
                aacId: '',
                amId: '',
                aaOwnerType: '',
                aaStatus: '',
                aaDateBuyStart: '',
                aaDateBuyEnd: '',
                aaDateAccountStart: '',
                aaDateAccountEnd: '',
                aaDateWarrantyStart: '',
                aaDateWarrantyEnd: '',
                aaDateWarrantyAccidentStart: '',
                aaDateWarrantyAccidentEnd: '',
                aaClassify: '',
                aaCategory: '',
                aaDisposalManner: '',
                aaDateDisposalStart: '',
                aaDateDisposalEnd: '',
                // 表头多选筛选参数(逗号分隔)
                aaClassifyListString: '',
                aaCategoryListString: '',
                aaOwnerTypeListString: '',
                aaNameListString: '',
                aubrBorrowDateListString: '',
                auDepartmentListString: '',
                aaAddressListString: '',
                aaPurchaseChannelsListString: '',
                amNameListString: '',
                aaDateWarrantyListString: '',
                aaDisposalMannerListString: '',
                aaDateBuyListString: '',
                aacNameListString: '',
                dmDelete: 1,
                currentPage: 1,
                pageSize: 20,
            };
            this.IsSerch = false;
            this.partserch()
        },
        SerchMore() {
            this.IsSerch = true;
        },
        getDetail(id) {
            getAjAssetsDetails({ aaId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            })
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjAssets({ aaIds: row.aaId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        // 打开财务核算编辑弹窗(回填当前值)
        openFinance(row) {
            this.formFinance = {
                aaId: row.aaId,
                aaName: row.aaName,
                aaOwnerType: row.aaOwnerType,
                aaMoneyBuy: row.aaMoneyBuy ?? '',
                aaMoneyOriginal: row.aaMoneyOriginal ?? '',
                aaDepreciationYears: row.aaDepreciationYears ?? '',
                aaResidualRate: row.aaResidualRate ?? '',
                aaDateAccount: row.aaDateAccount ?? '',
                aaDepreciatedMonths: row.aaDepreciatedMonths ?? '',
                aaMoneyHireMonth: row.aaMoneyHireMonth ?? '',
            };
            this.ISFinance = true;
        },
        // 提交财务核算(空字段不提交,由后端按默认规则自动计算)
        sureFinance() {
            this.$confirm("是否确定要编辑财务核算吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const data = { aaId: this.formFinance.aaId };
                    ['aaMoneyBuy', 'aaMoneyOriginal', 'aaDepreciationYears', 'aaResidualRate',
                        'aaDateAccount', 'aaDepreciatedMonths', 'aaMoneyHireMonth'].forEach(key => {
                            if (this.formFinance[key] !== '' && this.formFinance[key] != null) {
                                data[key] = this.formFinance[key];
                            }
                        });
                    updateAjAssetsFinance(data).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "财务核算编辑成功!",
                            });
                            this.ISFinance = false;
                            this.getList();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
},
	        // 初始化历史资产财务核算:为自购且原值为空的资产批量补算(采购单价>=5000→固定资产+年限平均法,否则低值易耗品)
	        // computeAll=1 可全量重算覆盖已算过的资产(慎用),默认只算原值为空的
	        initFinance() {
	            this.$confirm("将为自购历史资产批量初始化财务核算字段(固定资产/低值易耗品/折旧等), 是否继续?", "提示", {
	                confirmButtonText: "确定",
	                cancelButtonText: "取消",
	                type: "warning",
	            })
	                .then(() => {
	                    this.openLoading();
	                    initAjAssetsFinance({ computeAll: 1 }).then(res => {
	                        this.loadings.close();
	                        if (res.data) {
	                            this.$message({
	                                type: "success",
	                                message: "初始化完成: " + res.data,
	                            });
	                            this.getList();
	                        }
	                    }).catch(() => {
	                        this.loadings.close();
	                    })
	                }).catch(() => {
	                    this.$message({
	                        type: "info",
	                        message: "已取消",
	                    });
	                })
	        },
	        // 打开处置编辑弹窗(回填当前值)
        openDisposal(row) {
            this.formDisposal = {
                aaId: row.aaId,
                aaName: row.aaName,
                aaDateDisposal: row.aaDateDisposal ?? '',
                aaDisposalManner: row.aaDisposalManner ?? '',
                aaDisposalIncome: row.aaDisposalIncome ?? '',
                aaDes: row.aaDes ?? '',
            };
            this.ISDisposal = true;
        },
        // 提交处置(处置后每月1号折旧任务自动跳过该资产)
        sureDisposal() {
            this.$confirm("是否确定要编辑处置信息吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const data = { aaId: this.formDisposal.aaId };
                    ['aaDateDisposal', 'aaDisposalManner', 'aaDisposalIncome', 'aaDes'].forEach(key => {
                        if (this.formDisposal[key] !== '' && this.formDisposal[key] != null) {
                            data[key] = this.formDisposal[key];
                        }
                    });
                    updateAjAssetsDisposal(data).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "处置信息编辑成功!",
                            });
                            this.ISDisposal = false;
                            this.getList();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.aaFiles = data.aaFiles ? data.aaFiles.split(',') : [];
                console.log(this.form.aaFiles);
                if (data.aaFiles.length > 0) {
                    this.form.aaFiles.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })

                }

            })

        },
        SureBtn() {
            // 拥有方式为自购时不提交租用方式与月租单价(用副本避免影响页面显示)
            const data = { ...this.form };
            if (data.aaOwnerType == '自购') {
                delete data.aaMoneyHireManner;
                delete data.aaMoneyHireMonth;
            }
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        data.aaFiles = this.form.aaFiles.toString()
                        addAjAssets(data).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                data.aaFiles = this.form.aaFiles.toString()
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjAssets(data).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$nextTick(() => {
                this.fileList = []
                this.$refs['formRef'].resetFields();
            })
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            console.log(changeValue);
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aaId = row.aaId

                    updateAjAssets(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue && item[this.rowKeyname] == row[this.rowKeyname]) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.aaId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.aaId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                console.log(this.selectedRowKeysCollection);
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.aaId) > -1) {
                        console.log(item.aaId);
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.aaId), 1);
                    }
                });
                console.log(this.selectedRowKeysCollection);
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.aaId;
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjAssetsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjAssetsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjAssetsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>